import { render, staticRenderFns } from "./digitalServices.vue?vue&type=template&id=e61e4f44&scoped=true"
import script from "./digitalServices.vue?vue&type=script&lang=js"
export * from "./digitalServices.vue?vue&type=script&lang=js"
import style0 from "./digitalServices.vue?vue&type=style&index=0&id=e61e4f44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61e4f44",
  null
  
)

export default component.exports